import { LogHelper } from "../logging/log-helper";

export interface JsonValidationResult {
  valid: boolean;
  value: string;
  errorMessage?: string;
  isComplexObject?: boolean;
}

export class JsonValidator {
  /**
   * 
   * @param value the string to validate
   * @param initiator where the validation request was initiated, helps with debugging
   * @param textareaEl optional: if provided the invalid json will be highlighted within the text area
   * @returns 
   */
  public static validateJsonValue(value: string, initiator: string, textareaEl?: HTMLTextAreaElement): JsonValidationResult {
    let valid = false;
    let isComplexObject = false;
    let errorMessage: string = null;

    // an empty string should still be valid
    if(!value) valid = true;
    
    try {
      const parsed = JSON.parse(value);
      valid = (!!parsed && typeof parsed === 'object');
      value = JSON.stringify(parsed, null, 0);
      if(valid) {
        isComplexObject = !this.isSimpleJsonObject(parsed);
      }
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      errorMessage = error.toString();
      // since it is not a valid object we do not know if it is simple or not
      isComplexObject = true;
      if(textareaEl) {
        const match = errorMessage.match(/\d{1,4}/);
        if(match?.length) {
          const index = match[0]
          textareaEl.focus();
          textareaEl.setSelectionRange(parseInt(index, 10) - 2, parseInt(index, 10) + 2);
        }
      }
      LogHelper.debug(`${initiator} - Json Validation`, errorMessage);
    }
    return { valid, value, errorMessage, isComplexObject }
  }

  public static isSimpleJsonProperty(value: any) {
    return typeof (value) !== 'object' && !(value instanceof Array)
  }

  public static isSimpleJsonObject(value: object) {
    if(!value) return true;
    return Object.values(value).every(x => this.isSimpleJsonProperty(x));
  }
}